import React, { useState } from "react";
import { InboxOutlined } from "@ant-design/icons";
import { Upload, message } from "antd";
import { useTranslation } from "react-i18next";
import { GraphQLFetchData } from "../utils/graphQLFetchData";

const { Dragger } = Upload;

const UploadDocuments = ({ initialFileList = [], onFileListChange }) => {
  const { t } = useTranslation();
  const { uploadDocumentToS3 } = GraphQLFetchData();

  // 🔹 Normalize initial files to AntD format
  const normalizeToAntd = (docs) =>
    docs.map((doc, i) => ({
      uid: doc.uid || `${i}`, // unique id
      name: doc.fileName, // visible name in UI
      status: "done",
      url: doc.title,
    }));

  const [fileList, setFileList] = useState(normalizeToAntd(initialFileList));

  const ALLOWED_EXTENSIONS = ["pdf", "doc", "docx", "ppt", "pptx", "xls", "xlsx", "txt"];
  const MAX_DOC_SIZE_MB = 20;

  /** Validate file before upload */
  const beforeUpload = (file) => {
    const ext = file.name.split(".").pop()?.toLowerCase();
    const sizeMB = file.size / 1024 / 1024;

    if (!ext || !ALLOWED_EXTENSIONS.includes(ext)) {
      message.error(t("showEvent.extensions_doc_accepted_message"));
      return Upload.LIST_IGNORE;
    }
    if (sizeMB > MAX_DOC_SIZE_MB) {
      message.error(t("showEvent.maximum_document_size"));
      return Upload.LIST_IGNORE;
    }

    const isDuplicate = fileList.some((f) => f.name === file.name);
    if (isDuplicate) {
      message.warning(t("showEvent.fileAlreadyExists"));
      return Upload.LIST_IGNORE;
    }

    return true;
  };

  /** Upload handler */
//   const customRequest = async ({ file, onSuccess, onError }) => {
//     try {
//       const { data } = await uploadDocumentToS3({
//         variables: { file, subFolder: "attachedFile/" },
//       });

//       if (data?.uploadToS3?.code === "200") {
//         const fileUrl = data.uploadToS3.message;
//         const newFile = {
//           uid: file.uid,
//           name: file.name,
//           status: "done",
//           url: fileUrl,
//         };

//         const newFileList = [...fileList, newFile];
//         setFileList(newFileList);
//         // 🔹 Always notify parent with backend shape
//         onFileListChange?.(
//           newFileList.map((f) => ({
//             fileName: f.name,
//             attachementFilePath: f.url,
//           }))
//         );

//         onSuccess("ok");
//       } else {
//         throw new Error("Upload failed");
//       }
//     } catch (err) {
//       console.error("Upload failed:", err);
//       message.error(t("Translate.uploadError"));
//       onError(err);
//     }
//   };

const customRequest = async ({ file, onSuccess, onError }) => {
    try {
      const { data } = await uploadDocumentToS3({
        variables: { file, subFolder: "attachedFile/" },
      });
  
      if (data?.uploadToS3?.code === "200") {
        const fileUrl = data.uploadToS3.message;
        const newFile = {
          uid: file.uid,
          name: file.name,
          status: "done",
          url: fileUrl,
        };
  
        setFileList((prevList) => {
          const newFileList = [...prevList, newFile];
          onFileListChange?.(
            newFileList.map((f) => ({
              fileName: f.name,
              attachementFilePath: f.url,
            }))
          );
          return newFileList;
        });
  
        onSuccess("ok");
      } else {
        throw new Error("Upload failed");
      }
    } catch (err) {
      console.error("Upload failed:", err);
      message.error(t("Translate.uploadError"));
      onError(err);
    }
  };
  /** Handle remove */
  const handleRemove = (file) => {
    const newFileList = fileList.filter((f) => f.uid !== file.uid);
    setFileList(newFileList);

    onFileListChange?.(
      newFileList.map((f) => ({
        fileName: f.name,
        attachementFilePath: f.url,
      }))
    );
  };

  return (
    <Dragger
        multiple
      accept=".pdf,.doc,.docx,.ppt,.pptx,.xls,.xlsx,.txt"
      beforeUpload={beforeUpload}
      customRequest={customRequest}
      onRemove={handleRemove}
      fileList={fileList}
      showUploadList={{ showRemoveIcon: true }}
    >
      <p className="ant-upload-drag-icon">
        <InboxOutlined />
      </p>
      <p className="ant-upload-text">{t("Translate.documentUploadTitle")}</p>
      <p className="ant-upload-hint">{t("Translate.documentUploadHint")}</p>
    </Dragger>
  );
};

export default UploadDocuments;
